import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Self-hosted fonts (bundled into the build, so they load under the site's CSP without external requests)
import '@fontsource-variable/plus-jakarta-sans';
import '@fontsource-variable/inter';

// Absolute minimal React mounting
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Root element not found!');
  // Use safe DOM APIs instead of innerHTML to prevent potential XSS vectors.
  const wrapper = document.createElement('div');
  wrapper.style.padding = '20px';
  wrapper.style.textAlign = 'center';
  const heading = document.createElement('h1');
  heading.textContent = 'Error: Root element not found';
  wrapper.appendChild(heading);
  document.body.appendChild(wrapper);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);
}
